import PropTypes from 'prop-types';
export default {
  extent: PropTypes.arrayOf(PropTypes.number).isRequired,
  origin: PropTypes.arrayOf(PropTypes.number).isRequired,
  resolutions: PropTypes.arrayOf(PropTypes.number).isRequired
};